import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'columnFilter',
})
export class ColumnFilterPipe implements PipeTransform {

  transform(columns: any[], args?: any): any[] {
    return !columns ? [] : columns.filter( (c) => {
      return c.headerDisplay === args && c.headerDefault === args;
    } );
  }
}
